import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Chip from '@material-ui/core/Chip'
import Avatar from '@material-ui/core/Avatar'
import GridList from '@material-ui/core/GridList'
import Button from '@material-ui/core/Button'
import NearMe from '@material-ui/icons/NearMe'
import Mouse from '@material-ui/icons/Mouse'
import MyLocation from '@material-ui/icons/MyLocation'
import Tooltip from './Tooltip'
import isEmptyObject from '../utility/isEmptyObject'

const decimals = 4

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    overflow: 'hidden'
  },
  gridList: {
    flexWrap: 'nowrap'
  },
  chip: {
    margin: theme.spacing.unit
  }
})

const Location = ({ classes, bounds, center, handleClick, mouse }) => {
  if (
    !bounds ||
    !center ||
    !mouse ||
      isEmptyObject(bounds) ||
      isEmptyObject(center) ||
      isEmptyObject(mouse) ||
    center.length
  ) {
    return null
  }

  return (
    <div className={classes.root}>
      <GridList className={classes.gridList} cellHeight={'auto'} cols={2}>
          <Button size='small'><Mouse />{`${mouse.lat.toFixed(decimals)}, ${mouse.lng.toFixed(decimals)}`}</Button>
          <Button size='small' onClick={handleClick}><MyLocation />{`${center.lat.toFixed(decimals)}, ${center.lng.toFixed(decimals)}`}</Button>
      </GridList>
    </div>
  )
}

export default withStyles(styles)(Location)



// WEBPACK FOOTER //
// ./src/components/Location.js